export enum MenuMutationTypes {
  SET_OBRA = 'SET_OBRA',
  SET_CONTRATO = 'SET_CONTRATO',
  SET_CONTRATOS_USUARIO = 'SET_CONTRATOS_USUARIO',
  SET_OBRAS_USUARIO = 'SET_OBRAS_USUARIO'
}
